import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
//import { getAuctioneerLotDetails, getDefaultAuthToken } from '../../Api';
import Moment from 'react-moment';
import DataTable from '../DataTable';
import useApi from '../../api/useApi';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import lotImage from '../../images/lot.png'
import coloredLotImage from '../../images/lot-colored2.png'
import specialLotImage from '../../images/lot-special.png'
import lotSkipImage from '../../images/lot-skip.png'
import suspectedLotImage from '../../images/lot-yellow.png'
import { Draggable } from "react-drag-reorder";
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import BagContainer from './BagContainer';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { Button, Popover, OverlayTrigger, Overlay } from "react-bootstrap";

const LotGridView = () => {
    const navigate = useNavigate();
    const [lotSummary, setLotSummary] = useState({});
    const [selectedLot, setSelectedLot] = useState({});
    const [inputError, setInputError] = useState(false);
    const [suspectedLotCount, setSuspectedLotCount] = useState(0);
    const [specialLotCount, setSpecialLotCount] = useState(0);
    const [coloredLotCount, setColoredLotCount] = useState(0);
    const [lotDetailsData, setLotDetailsData] = useState([]);
    const [suspectionHistory, setSuspectionHistory] = useState([]);
    const [test, setTestData] = useState([1, 2, 3, 4, 5, 6]);
    const { id } = useParams();
    const api = useApi();
    let currentLotNumber = null;
    let rowColor = true;

    const loadLots = async () => {
        try {
            let lotData = await api.getLotOverview(parseInt(id));
            setLotDetailsData(lotData.details);
            setSuspectionHistory(lotData.history);

            const _suspectedLotCount = lotData.details.reduce((count, lot) => {
                return count + (lot.isSuspectedLot ? 1 : 0);
            }, 0);

            const _coloredLotCount = lotData.details.reduce((count, lot) => {
                return count + (lot.isColoredLot ? 1 : 0);
            }, 0);

            const _specialLotCount = lotData.details.reduce((count, lot) => {
                return count + (lot.isSpecialLot ? 1 : 0);
            }, 0);


            setSpecialLotCount(_specialLotCount);
            setSuspectedLotCount(_suspectedLotCount);
            setColoredLotCount(_coloredLotCount);

        } catch (error) {
            alert('Unable to fetch lot detail data.');
        }
    };

    const updateLotDetection = async (lot) => {
        try {
            await api.updateLotDetection(lot).then((response) => {
                if (response.success) {
                    loadLots();
                    alert(response.message);
                }
                else
                    alert(response.message);
            }).catch((error) => {
                console.error('Unable to update lot data', error);
            });
        } catch (error) {
            alert('Unable to update lot data.');
        }
    }

    const handleReasonChange = (event) => {
        setSelectedLot(prevState => ({
            ...prevState,
            reason: event.target.value
        }))
    };

    const onMarkSpecial = async (isSpecial) => {
        if (selectedLot) {
            setInputError(false);
            //if (selectedLot.reason !== undefined && selectedLot.reason !== null &&
            //    selectedLot.reason.toString().trim() !== "") {

            setSelectedLot(prevState => ({ ...prevState, isSpecialLot: isSpecial }));
            updateLotDetection({ ...selectedLot, isSpecialLot: isSpecial });
            setTimeout(() => {
                document.body.click();
            }, 100)
            //}
            //else
            //    setInputError(true);
        }
    }


    const onMarkSuspected = async (isSuspected) => {
        if (selectedLot) {
            setInputError(false);
            //if (selectedLot.reason !== undefined && selectedLot.reason !== null &&
            //    selectedLot.reason.toString().trim() !== "") {

            setSelectedLot(prevState => ({ ...prevState, isSuspectedLot: isSuspected }));
            updateLotDetection({ ...selectedLot, isSuspectedLot: isSuspected });
            setTimeout(() => {
                document.body.click();
            }, 100)
            //}
            //else
            //    setInputError(true);
        }
    }

    const onMarkColored = async (isColored) => {
        if (selectedLot) {
            setInputError(false);
            //if (selectedLot.reason !== undefined && selectedLot.reason !== null &&
            //    selectedLot.reason?.toString().trim() !== "") {

            setSelectedLot(prevState => ({ ...prevState, isSuspectedLot: !isColored ? false : true, isColoredLot: isColored }));
            updateLotDetection({ ...selectedLot, isSuspectedLot: !isColored ? false : true, isColoredLot: isColored });
            setTimeout(() => {
                document.body.click();
            }, 100)

            //}
            //else
            //    setInputError(true);
        }
    }

    const popover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">Lot Number : {selectedLot.lotNumber}</Popover.Header>
            <Popover.Body>
                <input type="text" value={selectedLot.reason} onChange={handleReasonChange} className={inputError ? "form-control mg-b-5 bd bd-danger" : "form-control mg-b-5"} placeholder="reason"></input>
                {!selectedLot.isSuspectedLot ? <button type="button" className="btn btn-danger btn-sm mg-r-10" onClick={() => onMarkSuspected(true)}>Mark Suspected</button> : null}
                {!selectedLot.isSuspectedLot && !selectedLot.isColoredLot && !selectedLot.isSpecialLot ? <button type="button" className="btn btn-warning btn-sm mg-r-10" onClick={() => onMarkSpecial(true)}>Mark Special</button> : null}
                {!selectedLot.isSuspectedLot && !selectedLot.isColoredLot && selectedLot.isSpecialLot ? <button type="button" className="btn btn-outline-warning btn-sm mg-r-10" onClick={() => onMarkSpecial(false)}>Mark Not Special</button> : null}
                {!selectedLot.isColoredLot && selectedLot.isSuspectedLot ? <button type="button" className="btn btn-success btn-sm mg-r-10" onClick={() => onMarkSuspected(false)}>Mark Not Suspected</button> : null}
                {!selectedLot.isColoredLot && selectedLot.isSuspectedLot ? <button type="button" className="btn btn-danger btn-sm" onClick={() => onMarkColored(true)}>Mark Colored</button> : null}
                {selectedLot.isColoredLot ? <button type="button" className="btn btn-success btn-sm" onClick={() => onMarkColored(false)}>Mark Not Colored</button> : null}
            </Popover.Body>
        </Popover>
    );


    useEffect(() => {
        loadLots();
    }, []);

    const updateLotStatus = (e, lotId, status) => {

        e.preventDefault();
        const updatedLotDetailsData = lotDetailsData.map((lot) =>
            lot.lotId === lotId ? { ...lot, lotType: status } : lot
        );

        // Update the state with the modified array
        setLotDetailsData(updatedLotDetailsData);
    }

    const saveLotDetail = () => {

        const lotPriceData = lotDetailsData.map(t => {
            return {
                lotId: t.lotId,
                auctionId: t.auctionId,
                auctionStartPriceRs: t.auctionStartPriceRs,
                reservedPrice: t.reservedPrice,
            }
        })
        console.log(lotDetailsData)
        //api.saveLotPrice(lotPriceData)
        //    .then((response) => {
        //        fetchDataFromApi();
        //        alert("Record updated successfully");
        //    })
        //    .catch((error) => {
        //        // Handle error
        //        console.error('Error saving lot price data:', error);
        //    });
    };

    const onLotSelected = (lot) => {
        setInputError(false);
        setSelectedLot(lot)
    }

    const renderProductGrid = (lot, index) => {
        return (
            <OverlayTrigger
                key={index}
                trigger="click"
                placement="top"
                overlay={popover}
                rootClose={true}
            >
                <div key={index}
                    className="product-grid"
                    onClick={() => onLotSelected(lot)}
                >
                    <div className="product-image bd popover-bag-container">
                        {
                            lot.isColoredLot ?
                                <img className="pic-1" alt="product1" src={coloredLotImage} />
                                : lot.isSuspectedLot ?
                                    <img className="pic-1" alt="product1" src={suspectedLotImage} />
                                    : lot.isSpecialLot ?
                                        <img className="pic-1" alt="product1" src={specialLotImage} />
                                        : lot.status === 7 ?
                                            <img className="pic-1" alt="product1" src={lotSkipImage} />
                                            : <img className="pic-1" alt="product1" src={lotImage} />
                        }
                        <span>{lot.lotNumber}</span>
                    </div>
                </div>
            </OverlayTrigger>
        );
    };


    return (
        <div>
            <div className="inner-body mg-t-30">
                <div className="page-header">
                    <div>
                        <h2 className="main-content-title tx-24 mg-b-5">Bag view</h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a className="custom-link" onClick={() => navigate('/home')}>Home</a></li>
                            <li className="breadcrumb-item " aria-current="page">
                                <a className="custom-link" onClick={() => navigate('/auctions')}>Auctions</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Bag view</li>
                        </ol>
                    </div>
                    
                </div>
                <div className="row row-sm">
                    <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 grid-margin">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div className="border-bottom-0 mg-b-10">
                                    <div className="d-flex flex-column justify-content-between">
                                        <div>
                                            <span className="d-block tx-12 mb-0 text-muted">Hover and click on the lot to view action item. You can update the status of the lot here.</span>
                                        </div>
                                        <div className="d-flex justify-content-evenly mg-t-8 pd-8" style={{ backgroundColor: "#eaedf7" }}>
                                            <div className="me-4">
                                                <span class="me-1 badge rounded-pill bg-parrot-green">{specialLotCount}</span>
                                                <span>Speical Lots</span>
                                            </div>
                                            <div className="me-4">
                                                <span class="me-1 badge rounded-pill bg-warning-dark">{suspectedLotCount}</span>
                                                <span>Suspected Lots</span>
                                            </div>
                                            <div className="me-3">
                                                <span class="me-1 badge rounded-pill bg-danger-dark">{coloredLotCount}</span>
                                                <span>Colored Lots</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/*<DndProvider backend={HTML5Backend}>*/}
                                {/*    <BagContainer data={lotDetailsData} />*/}
                                {/*</DndProvider>*/}


                                {lotDetailsData?.length === 0 ?
                                    <div className="wd-20p">
                                        <span>Please wait...</span>
                                        <Skeleton containerClassName="" height={16} count={1} />
                                    </div> : null}

                                <div className="d-flex flex-wrap ht-400 overflow-auto">
                                    {lotDetailsData?.map((t, index) => renderProductGrid(t, index))}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 grid-margin">
                        <div className="card custom-card">
                            <div className="card-body  pd-l-15 pd-r-15">
                                <div className="border-bottom-0 mg-b-10">
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <label className="main-content-label mb-2">Suspection History</label>
                                        </div>
                                    </div>

                                </div>
                                <div className="ht-450 overflow-scroll">
                                    <table className="wd-100p table-stripped tx-13 ">
                                        <tr className="bg-primary">
                                            <td className="wd-35p text-center"> <small> Lot No/<br></br> Current Status</small></td>
                                            <td ><small>History</small> </td>
                                        </tr>
                                        {suspectionHistory.map((t, index) => {
                                            const renderLotNumber = t.lotNumber !== currentLotNumber;

                                            if (renderLotNumber) {
                                                currentLotNumber = t.lotNumber;
                                                rowColor = !rowColor
                                                return (
                                                    <tr key={index} className={rowColor ? 'bg-light bd-t' : 'bd-t'}>
                                                        <td className="text-center d-flex flex-column">
                                                            <span> {t.lotNumber}</span>
                                                            <small> {t.isColoredLot ? 'COLORED' : t.isSuspectedLot ? 'SUSPECTED' : ''}</small>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <small className="pd-0 mg-r-4">Suspected : <strong>{t.isSuspectedLot ? 'Yes' : 'No'}</strong> </small>
                                                                <small className="pd-0">Colored : <strong>{t.isColoredLot ? 'Yes' : 'No'}</strong> </small>
                                                            </div>
                                                            <div className="d-flex flex-column justify-content-between mg-b-5">
                                                                <small className="pd-0"><i> {t.comment}</i> </small>
                                                                <small className="text-muted tx-8"><i><Moment format="DD-MMM-YY hh:mm LT">{t.addedOn}</Moment></i> </small>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            } else {
                                                return (
                                                    <tr key={index} className={rowColor ? 'bg-light' : ''}>
                                                        <td></td>
                                                        <td className="bd-t">
                                                            <div className="d-flex">
                                                                <small className="pd-0 mg-r-4">Suspected : <strong>{t.isSuspectedLot ? 'Yes' : 'No'}</strong> </small>
                                                                <small className="pd-0">Colored : <strong>{t.isColoredLot ? 'Yes' : 'No'}</strong> </small>
                                                            </div>
                                                            <div className="d-flex  flex-column justify-content-between mg-b-5">
                                                                <small className="pd-0"><i> {t.comment}</i> </small>
                                                                <small className="text-muted tx-8"><i><Moment format="DD-MMM-YY hh:mm LT">{t.addedOn}</Moment></i> </small>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        })}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );


}


export default LotGridView;